import { styled } from "@vw-marketing/us-components";

export const StyledBodyContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap}px;
`;

export const StyledUpperContainer: any = styled.div`
  padding: 0;  
  width: 100%;
`;

export const StyledLowerContainer: any = styled.div`
  padding: 0;  
  width: 100%;
`;